import commonMapping from "@/mapping/common";

const acl_default_policy_list = [
  { id: "allow_all", value: "allow_all", config: "allow", label: "allow_connect" },
  { id: "block_all", value: "block_all", config: "block", label: "block_connect" },
];

const acl_strategy_list = [
  { value: "allow", config: "0", label: "allow_mark" },
  { value: "block", label: "block_mark", config: "1" },
];
export const accessControl = {
  acl_enable: commonMapping.intToBoolean,
  acl_default_policy: acl_default_policy_list,
  acl_strategy: acl_strategy_list,
};

export default accessControl;
